import { gql, QueryHookOptions } from '@apollo/client';
import { GraphQLResponsePaginationInfo, Template } from 'modules/graphql';
import {
  DEFAULT_PAGINATION as pagination,
  DEFAULT_SORT_BY as sortBy,
  DEFAULT_SORT_DIRECTION as sortDirection,
} from 'modules/quickActionsMenu/constants';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GraphQLVariables } from '../types';

const getQuickActionsTemplates = gql`
  query getQickActionsTemplates($pagination: Pagination, $search: String, $sort: Sort) {
    templates(pagination: $pagination, sort: $sort, search: $search) {
      info {
        count
        limit
        offset
        page
      }
      results {
        contentPreview
        id
        messageMedium
        name
      }
    }
  }
`;

type GraphQLResponse = {
  templates: {
    info: GraphQLResponsePaginationInfo;
    results: Pick<Template, 'contentPreview' | 'id' | 'messageMedium' | 'name'>[];
  };
};

export const useQueryTemplates = (
  search: string,
  options?: QueryHookOptions<GraphQLResponse, GraphQLVariables>,
) =>
  useGraphql<GraphQLResponse>(getQuickActionsTemplates, {
    ...options,
    notifyOnNetworkStatusChange: true,
    variables: {
      search,
      sort: { sortBy, sortDirection },
      pagination,
    },
  });
